import PropTypes from 'prop-types';
import cls from 'classnames'

import { getAsset, isWHEnv } from '@/utils/helper';

import Text from '@/atoms/Text/Text';
import { DynamicAsset, Media } from '@/molecules/Media/index';

import { CtfChefIntroStyle } from '@/utils/constants';

export default function ChefIntroduction({ assets, entries, fields }) {
  const photo = getAsset(fields?.photo?.sys?.id, assets)?.fields;

  return (
    <div
      className={cls('aaco-chef-introduction',
        'w-auto md:w-2/3',
        'flex flex-wrap flex-col gap-y-2.5',
        'p-6 md:p-0 dd-kr:pl-[21px] dd-en:pl-[21px] dd-kr:ml-5 dd-en:ml-5 md:ml-0 dd-en:md:ml-5 dd-kr:md:ml-5 mb-[52px] dd-en:mb-6 dd-kr:mb-6 md:mb-20',
        'dd-kr:border-l-2 dd-en:border-l-2 border-warm-grey ',
        'whitespace-pre-line')}
      id="chef-introduction"
    >
      {photo && !fields?.cloudinaryAsset && (
        <Media
          style="rounded-full !h-20 !w-20 border-black border object-center"
          mediaUrl={photo?.file?.url}
          title={photo?.title}
          fullSize={false}
        />
      )}
      {fields?.cloudinaryAsset && (
        <DynamicAsset
          assets={assets}
          entries={entries}
          field={fields.cloudinaryAsset}
          title={fields.chefName}
          style="!h-20 !w-20 rounded-full border-black border object-center"
          container="chef"
          fullSize={false}
        />
      )}
      <Text tag="tag" style="text-dark-warm-grey">
        {fields?.style === CtfChefIntroStyle.RESTAURANT && 'OWNER & CHEF'}
        {fields?.style === CtfChefIntroStyle.CUSTOM && fields?.subtitle}
        {(!fields?.style || fields?.style === CtfChefIntroStyle.RECIPE) &&
          'RECIPE BY'}
      </Text>
      <Text tag="h5" style="block md:hidden text-black">
        {fields.chefName}
      </Text>
      <Text tag="h6" style="hidden md:block text-black">
        {fields.chefName}
      </Text>
      <hr className="border-black" />
      <Text style="text-black pt-4">{fields.description}</Text>
    </div>
  );
}

ChefIntroduction.propTypes = {
  assets: PropTypes.array,
  fields: PropTypes.shape({
    chefName: PropTypes.string,
    description: PropTypes.string,
    photo: PropTypes.object,
  }),
};

ChefIntroduction.defaultProps = {
  fields: {},
  assets: [],
};
